import { common_icons_ids } from '@shared/icon-components/common-icons.ids';

export const loading_toaster_default_strings = {
  iconType: common_icons_ids.error,
} as const;
